export const stageOptions = [
  { label: "All", value: "", default: true },
  { label: "Pending", value: "1" },
  { label: "In-progress", value: "2" },
  { label: "Query Done", value: "3" },
  { label: "Re-opened", value: "4" },
  { label: "Cold Follow-up's", value: "5" },
];
